import getField from '@form/formGenerator'

export const missionSubjectSaveUrl = `${import.meta.env.VITE_API_URL}/api/mission-subjects`

export const missionSubjectFormObject = {
  id: null,
  subject: null,
  parent: '',
  formConfig: {
    withUnits: false,
    withEggs: false,
    withChicks: false,
    withSurface: false
  }
}

export const missionSubjectFormFields = (missionSubjectObject, updateFormObject, saveForm, errors, isLoading, t, data) => {
  const fields = [{
    type: 'select',
    name: 'parent',
    label: t('labels.parent'),
    value: 'object' === typeof missionSubjectObject.parent ? missionSubjectObject.parent.id : missionSubjectObject.parent,
    key: 'missionSubjectObject-parent',
    cssClass: 'column is-12',
    withIcon: false,
    options: data.missionSubjects,
    disabled: false,
    error: []
  },
  {
    type: 'text',
    name: 'subject',
    label: t('labels.subject'),
    value: missionSubjectObject.subject,
    key: 'missionSubjectObject-subject',
    cssClass: 'column is-12'
  },
  {
    type: 'switcher',
    name: 'formConfig.withUnits',
    label: t('labels.with_units'),
    value: missionSubjectObject.formConfig.withUnits,
    cssClass: 'column is-12',
    key: 'missionSubjectObject-withUnits',
    id: 'missionSubjectObject-withUnits'
  },
  {
    type: 'switcher',
    name: 'formConfig.withChicks',
    label: t('labels.with_chicks'),
    value: missionSubjectObject.formConfig.withChicks,
    cssClass: 'column is-12',
    key: 'missionSubjectObject-withChicks',
    id: 'missionSubjectObject-withChicks'
  },
  {
    type: 'switcher',
    name: 'formConfig.withEggs',
    label: t('labels.with_eggs'),
    value: missionSubjectObject.formConfig.withEggs,
    cssClass: 'column is-12',
    key: 'missionSubjectObject-withEggs',
    id: 'missionSubjectObject-withEggs'
  },
  {
    type: 'switcher',
    name: 'formConfig.withSurface',
    label: t('labels.with_surface'),
    value: missionSubjectObject.formConfig.withSurface,
    cssClass: 'column is-12',
    key: 'missionSubjectObject-withSurface',
    id: 'missionSubjectObject-withSurface'
  },
  {
    type: 'button',
    buttons: true,
    callback: saveForm,
    cancel: false,
    validateText: t('actions.save'),
    cssClassParent: 'column is-12',
    cssClassValidate: 'button is-blue',
    validateIcon: 'icon-done',
    key: 'missionSubjectObject-form',
    isLoading
  }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}